import React from 'react';
import PropTypes from 'prop-types';

const iconHeart3 = ({ className }) => (
    <svg
      width="36px"
      height="33px"
      className={className}
      viewBox="0 0 36 33"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-400.000000, -2918.000000)"
          fill="#27919C"
          fillRule="nonzero"
        >
          <g
            id="Product/Favourite"
            transform="translate(400.000000, 2917.000000)"
          >
            <path
              d="M18.0895822,5.21861312 C17.9771484,5.09419406 17.8615668,4.97257657 17.7428701,4.85387987 C13.7694282,0.882124446 7.32900819,0.882124446 3.35421759,4.8535423 C-0.617931817,8.82737807 -0.617931817,15.2710584 3.35387987,19.2428701 L17.2917943,33.1837845 C17.7311035,33.6231883 18.4434472,33.6232458 18.8828273,33.1839129 L32.8253273,19.2429129 C36.7971818,15.2710584 36.7971818,8.82737807 32.825539,4.85404875 C28.8518719,0.882068183 22.4081916,0.882068183 18.4363799,4.85387987 C18.3175874,4.97267235 18.2020067,5.09425862 18.0895822,5.21861312 Z M31.2343799,17.6518799 L18.0875034,30.7973419 L4.94495573,17.6519655 C1.85168182,14.5586916 1.85168182,9.53937193 4.94503897,6.44470125 C8.04074181,3.35162555 13.0573218,3.35162555 16.1520487,6.44503897 C16.5236904,6.81668067 16.8573577,7.22701905 17.151068,7.67027905 C17.5954249,8.34089109 18.5795989,8.341929 19.0253693,7.67225569 C19.3224958,7.22588752 19.6552935,6.81694676 20.0273701,6.44487013 C23.1205022,3.35173809 28.1396954,3.35168182 31.2343799,6.44487015 C34.3275682,9.53955456 34.3275119,14.5587478 31.2343799,17.6518799 Z"
              id="Favourite"
            />
          </g>
        </g>
      </g>
    </svg>
  );

iconHeart3.propTypes = {
  className: PropTypes.string
}

export default iconHeart3;
